import { render, staticRenderFns } from "./ObjectSort.vue?vue&type=template&id=5da91d12&scoped=true"
import script from "./ObjectSort.vue?vue&type=script&lang=js"
export * from "./ObjectSort.vue?vue&type=script&lang=js"
import style0 from "./ObjectSort.vue?vue&type=style&index=0&id=5da91d12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da91d12",
  null
  
)

export default component.exports